import React, { useState, useEffect } from "react";
import axios from "axios";

// E-Mails werden nur noch serverseitig verschickt; der Mail-Test-Button wurde deshalb entfernt.
const Status = () => {
  const [dbStatus, setDbStatus] = useState("Checking...");
  const [dbMessage, setDbMessage] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get("/api/dbXstatus", { headers: { 'Cache-Control': 'no-cache' } })
      .then((response) => {
        if (response.data.status === 'success') {
          setDbStatus("Connected to the database");
          setDbMessage(response.data.message);
        } else if (response.data.status === 'warning') {
          setDbStatus("Connected, but no data found");
          setDbMessage(response.data.message);
        } else {
          setDbStatus("Failed to connect to the database");
          setDbMessage(response.data.message);
        }
      })
      .catch((err) => {
        setDbStatus("Failed to connect to the database");
        setDbMessage("An error occurred");
        setError(err.message);
      });
  }, []);

  // Nur für angemeldete Admins (Token hängt der axios-Interceptor aus AuthContext an)
  const handleInsert = () => {
    axios
      .post("/api/dbXpost")
      .then(() => {
        alert("Timestamp inserted successfully!");
      })
      .catch((error) => {
        alert("Failed to insert timestamp: " + error.message);
      });
  };

  return (
    <div>
      <h2>System Status</h2>
      <table>
        <thead>
          <tr>
            <th>Component</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Verbunden mit:</td>
            <td>{process.env.REACT_APP_URL_HOST}</td>
          </tr>
          <tr>
            <td>Verbunden mit Datenbank:</td>
            <td style={{ color: dbStatus === 'Connected to the database' ? 'green' : 'red' }}>
              {dbMessage}
            </td>
          </tr>
        </tbody>
      </table>
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}
      <button onClick={handleInsert}>Insert Timestamp</button>
    </div>
  );
};

export default Status;
